<script setup lang="ts">

import {ArrowDownTrayIcon, DocumentTextIcon, GlobeAltIcon} from "@heroicons/vue/24/outline";
import {i18n} from "@/services/support/i18n";
</script>

<template>
  <div class="profile-unit grid grid-cols-1 gap-y-2">

    <a class="link-box" href="/pdf/podminky-uzivani.pdf" target="_blank">
      <ArrowDownTrayIcon class="h-5 w-5 text-cez-color"/>
      <span>{{ i18n.termsAndConditions }}</span>
    </a>

    <a class="link-box" href="/pdf/pravidla-souteze.pdf" target="_blank">
      <ArrowDownTrayIcon class="h-5 w-5 text-cez-color"/>
      <span>{{ i18n.competitionRules }}</span>
    </a>

    <a class="link-box" href="/ochrana-osobnich-udaju">
      <DocumentTextIcon class="h-5 w-5 text-cez-color" aria-hidden="true"/>
      <span>{{ i18n.privacyPolicy }}</span>
    </a>

    <a class="link-box" href="https://www.cezdistribuce.cz/cs/prokop-divis" target="_blank">
      <GlobeAltIcon class="h-5 w-5 text-cez-color" aria-hidden="true"/>
      <span>{{ i18n.contactCez }}</span>
    </a>
  </div>
</template>

<style scoped>
.link-box {
  @apply bg-gray-900 p-2 mb-1 rounded-md border-cez-color border flex items-center gap-x-2 text-sm;
}
</style>